import React, {useState} from "react";
import { observer } from "mobx-react-lite";
import { Table, Button, Modal, Form, Input, message } from "antd";
import { useShift } from "../../app/hooks/useShift";
import { useEmployeeShiftCode } from "../../app/hooks/useEmployeeShiftCode";

const ShiftScheduleList = () => {
  const { getById, update } = useEmployeeShiftCode();

  const { data, mutate } = useShift({
    pageNumber: 0,
    pageSize: 9999,
    sort: "date_descend",
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingShift, setEditingShift] = useState(null);
  const [form] = Form.useForm();

  const openEditModal = async (shiftCodeId) => {
    try {
      const response = await getById(shiftCodeId);
      setEditingShift(response);
      form.setFieldsValue({ description: response.description });
      setIsModalVisible(true);
    } catch {
      message.error("Failed to fetch shift data.");
    }
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await update({ ...editingShift, description: values.description });
      mutate(); 
      message.success("Shift code updated successfully.");
      setIsModalVisible(false);
    } catch {
      message.error("Update failed.");
    }
  };

  const columns = [
    {
      title: "Shift Name",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Button type="link" onClick={() => openEditModal(record.id)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <div>
      <h2>Shift Schedule List</h2>
      <Table
        dataSource={data || []}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        bordered
      />

      <Modal
        title="Edit Shift Code"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={() => setIsModalVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="description"
            label="Shift Code Name"
            rules={[
              { required: true, message: "Please enter shift code name" },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default observer(ShiftScheduleList);
